import api from '#config/api';

export const signIn = user => api.post('/sign_in', user);

export const signInAdmin = phone => api.post('/admin/sign_in', { phone });

export const getCurrentUser = () => api.get('/me');
